import {
  isThisArrayEmpty,
  isThisArrayNotEmpty,
  isThisArrayThisLength,
} from "../../../services/helpers/commonHelpers";
import { OptionType } from "../../../services/helpers/types";
import { ValueObjectType } from "../../organisms/CascaderField/helpers";

export const checkBaseCheckbox = (
  option: OptionType,
  currentValueObject: ValueObjectType
) => {
  const currentObjectKeys = Object.keys(currentValueObject);
  const currentObjectValues = currentValueObject[option.name];
  if (
    currentObjectKeys.includes(option.name) &&
    isThisArrayEmpty(currentObjectValues)
  ) {
    return true;
  }

  if (isThisArrayThisLength(currentObjectValues, option.subOptions?.length)) {
    return true;
  }
  return false;
};

export const checkIndeterminate = (
  option: OptionType,
  currentValueObject: ValueObjectType
) => {
  const currentObjectKeys = Object.keys(currentValueObject);
  const currentObjectValues = currentValueObject[option.name];
  if (isThisArrayThisLength(currentObjectValues, option.subOptions?.length)) {
    return false;
  }
  if (
    currentObjectKeys.includes(option.name) &&
    isThisArrayNotEmpty(currentObjectValues)
  ) {
    return true;
  }

  return false;
};
